<!--
  作用： 显示超过三行，提供hover显示tooltip的功能。
  @props content <string> 传递文字内容。
          必传内容
  @props color <string> 超过三行内容之后显示省略号的背景颜色设置
          默认为黑色底色：#03050b
-->
<template>
  <el-tooltip placement="bottom" popper-class="textTooltip" :disabled="flag">
    <div class="text-wrapper" slot="content">{{content}}</div>
    <div class="multiple-wrap" :ref="`multiple-wrap${index}`">
      <div class="multiple-content" :ref="`multiple-content${index}`">{{content}}</div>
      <i
        class="more"
        v-if="!flag"
        :style="gradient"
      >...</i>
    </div>
  </el-tooltip>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      required: true,
    },
    // dark 黑色底色：#03050b white 白色底色：#fff
    color: {
      type: String,
      default: '#03050b',
    },
  },
  computed: {
    gradient() {
      return ` background: linear-gradient(to right, transparent, ${this.color} 55%);`;
    },
  },
  data() {
    return {
      index: Math.random(),
      flag: false,
    };
  },
  methods: {
    overHeight(index) {
      this.$nextTick(() => {
        const wrapheight = this.$refs[`multiple-wrap${index}`];
        const contentheight = this.$refs[`multiple-content${index}`];
        if (contentheight.offsetHeight > wrapheight.offsetHeight) {
          this.flag = false;
        } else if (contentheight.offsetHeight <= wrapheight.offsetHeight) {
          this.flag = true;
        }
      });
    },
  },
  created() {
    this.overHeight(this.index);
  },
};
</script>

<style lang="scss" scoped>
.textTooltip {
  .text-wrapper {
    width: 300px;
    line-height: 18px;
  }
}
.multiple-wrap {
  position: relative;
  cursor: pointer;
  font-size: 1em;
  line-height: 1.8em; // 行高很重要，一定要设置
  max-height: 5.4em; // 最大高度是行高的倍数
  overflow: hidden;
  word-break: break-all;
  i.more {
    position: absolute;
    display: inline-block;
    width: 40px;
    height: 1.8em; // 此处高度应和行高一致
    bottom: 0;
    right: 0;
    text-align: right;
    font-size: 1em;
  }
}
</style>
